import React from 'react';
import './Home_card2.css'

const Home_card2 = (props) => {
    return ( 
        <div className='home_card2_div2'>
            <img className='home_card2_icon' src={props.img} alt="" />
            <h4 className='home_card2_text1'>{props.title}</h4>
            <h6 className='home_card2_text2'>{props.subtitle}</h6>
        </div>
    );
}
 
export default Home_card2 ;